import styled from 'styled-components';

export const FloorplanWrapper = styled.div`
  background: url('/public-assets/images/interactive-floorplan/render.jpg')
    center center no-repeat;
  background-size: contain;
  backface-visibility: hidden;
  cursor: pointer;
  height: 2895px;
  position: absolute;
  transform: ${(props) => (props.zoomed ? 'scale(1)' : 'scale(0.33)')};
  transition: ${(props) => (props.dragging ? '' : 'all 1400ms ease-in-out')};
  transition-property: left, top, transform;
  width: 4950px;
  z-index: 1;

  @media not all and (min-resolution: 0.001dpcm) {
    /* Safari 10.1+ */
    background: url('/public-assets/images/interactive-floorplan/render-small.jpg')
      center center no-repeat;
    background-size: contain;
    cursor: pointer;
    height: 1667px;
    width: 2900px;
  }
  @media (max-width: 970px) {
    background: url('/public-assets/images/interactive-floorplan/render-small.jpg')
      center center no-repeat;
    background-size: contain;
    cursor: pointer;
    height: 1667px;
    width: 2900px;
  }
`;
